/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=479710cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=479710cc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479710cc"]])

export default __exports__